
    import Vue from 'vue';
    import { SettingService } from '@/services/SettingService';
    import { ApplicationSetting } from '../../models/Enums';
    import { mapGetters } from "vuex";
    import { SnackbarService } from "@/services/SnackbarService";
 
    export default Vue.extend({
        data() {
            return {
                items: [] as any[],
                loading: true,

                birthdateFormats: ['ÅÅÅÅMMDD', 'ÅÅÅÅMM', 'ÅÅÅÅ'],

                imageLogoFile: null,
                selectedFile: null,
            }
        },
        created() {
            //  console.log("ApplicationSettings!!!");
            this.getSettings();
            this.getMunicipalityLogo();
        },
        methods: {
            getApplicationSettingName(app: ApplicationSetting) {
                return this.$vuetify.lang.t('$vuetify.applicationsetting.' + ApplicationSetting[app]);
            },

            getApplicationSettingIndex(app: ApplicationSetting) {
                return this.items.findIndex((val: any) => val.keyName == app);
            },


            saveLogo() {

                if (!this.selectedFile) { //NoFileUploaded
                    SnackbarService.addErrorMessage(this.$vuetify.lang.t('$vuetify.importPersons.NoFileUploaded'));
                }

                let formData = new FormData();

                formData.append('image', this.selectedFile!);

                SettingService.SaveImage(formData,"MunicipalityLogo").then(() => {

                    this.getSettings();
                    this.getMunicipalityLogo();
                    this.selectedFile = null;
                    SnackbarService.addSuccessMessage(this.$vuetify.lang.t('$vuetify.saved'));
                
                }).catch((error) => {
                    SnackbarService.addErrorMessage(
                        error.response?.data || error.response?.statusText
                    );
                }).finally(() => {
             
                });

              
            },

            removeLogo() {
               
                SettingService.RemoveImage("MunicipalityLogo").then(() => {
                    
                    this.getSettings();
                    this.getMunicipalityLogo();
                    SnackbarService.addSuccessMessage(this.$vuetify.lang.t('$vuetify.saved'));

                }).catch((error) => {
                    SnackbarService.addErrorMessage(
                        error.response?.data || error.response?.statusText
                    );
                }).finally(() => {
                    
                });
            
            },


            async getSettings() {
                this.loading = true;

                this.$store.commit('addOverlay');

                SettingService.GetSettings().then(response => {
                    this.items = response.data;    
                }).catch((error) => {
                    console.error(error);
                }).finally(() => {
                    this.loading = false;
                    this.$store.commit('removeOverlay');
                });
            },

            async getMunicipalityLogo() {              

                SettingService.GetMunicipalityLogo().then(response => {
                
                    this.imageLogoFile = response.data!;
                }).catch((error) => {
                    console.error(error);
                }).finally(() => {
                  
                });               

            },

            async submit() {

                this.$store.commit('addOverlay');             

                if (this.items[this.getApplicationSettingIndex(2)].value === 'True') {
                    this.items[this.getApplicationSettingIndex(3)].value = this.birthdateFormats[0];
                }

                SettingService.SaveSetting(this.items).then(() => {                
                
                    this.getSettings();
                    SnackbarService.addSuccessMessage(this.$vuetify.lang.t('$vuetify.saved'));

                }).catch((error) => {
                    if (error.response.data.errors) {
                        SnackbarService.addErrorMessage(error.response?.data || error.response?.statusText);
                    } else {
                        SnackbarService.addErrorMessage(this.$vuetify.lang.t('$vuetify.generalErrorMessage'));
                    }                   
                }).finally(() => {
                    this.$store.commit('removeOverlay');
                });
            
            }
        },
        computed: {
            ...mapGetters([
                "isSystemAdmin",
                "isMunicipalityAdmin"               
            ]),
        }
    });
